import { type ZodError } from 'zod';

export const hasZodValidationError = (
  paths: ReadonlyArray<RegExp | string> | RegExp | string,
  validationError: null | ZodError,
): boolean => {
  if (!validationError) return false;
  if (validationError.isEmpty) return false;

  const pathArray = Array.isArray(paths) ? paths : [paths];

  if (validationError?.errors?.length > 0) {
    return validationError.errors.some((error) => {
      const errorPath = error.path.join('.');
      if (errorPath) {
        return pathArray.some((path) => {
          if (typeof path === 'string') {
            return path === errorPath;
          }

          return path.test(errorPath);
        });
      }

      return false;
    });
  }

  return false;
};
